/**
 * @file AssetNotificationsPanel.js
 * @description This panel populates the notifications associated with an asset.
 */

import { useState, useEffect } from 'react';
import styles from '../AssetDrawer.module.scss';
import { useNavigate } from 'react-router';
import { SecurityAttributes } from '../../../utils/data/enums';
import { useAuthContext } from '../../../store/AuthContext';
import { formatDateToMMDDYYYY } from '../../helpers/DateUtils';
import { ROUTE_BUILDERS } from '../../../constants/routes';
import { getText } from '../../../i18n';

const AssetNotificationsPanel = ({ asset }) => {
    const navigate = useNavigate();
    const { user, hasAttribute } = useAuthContext();
    const [sortedNotifications, setSortedNotifications] = useState([]);

    useEffect(() => {
        if (asset?.notifications) {
            const sortedNotificationsArray = [...asset.notifications].sort(
                (a, b) => a.name.localeCompare(b.name),
            );
            setSortedNotifications(sortedNotificationsArray);
        }
    }, [asset]);

    const getName = index => {
        let name = '';
        name = sortedNotifications[index].name;
        return name;
    };

    const getId = index => {
        let id = 1;
        id = sortedNotifications[index].id;
        return id;
    };

    const getSent = index => {
        let sentAt = '-';
        sentAt = formatDateToMMDDYYYY(sortedNotifications[index].sentAt);
        return sentAt;
    };

    const getScheduled = index => {
        let scheduledFor = '-';
        scheduledFor = formatDateToMMDDYYYY(
            sortedNotifications[index].scheduledFor,
        );
        return scheduledFor;
    };

    return (
        <>
            <p className={styles.portalsPanelTitle}>{getText('msg_753a22b2eb61')}</p>
            <div className={styles.assetPortalsPanel}>
                <div className={styles.portalsContent}>
                    {sortedNotifications.map((event, index) => (
                        <div key={event.id} className={styles.portalsEntry}>
                            <div className={styles.portalsHeader}>
                                <div style={{ marginBottom: '10px' }}>
                                    <span className={styles.portalsName}>
                                        {getName(index)}
                                    </span>
                                    {hasAttribute(
                                        SecurityAttributes.NotificationFullAccess
                                    ) && (
                                            <p
                                                className={styles.heading}
                                                onClick={() =>
                                                    navigate(
                                                        ROUTE_BUILDERS.messagesView(
                                                            getId(index),
                                                        ),
                                                    )
                                                }
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#007BFF',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {getText('msg_69bd4ef9fbd0')}
                                            </p>
                                        )}
                                </div>
                                {getSent(index) !== '-' && (
                                    <div>
                                        {getText('msg_35f49dcfbfb2')}
                                        <span
                                            className={styles.portalsStatus}
                                            style={{ marginLeft: '4px' }}
                                        >
                                            {getSent(index)}
                                        </span>
                                    </div>
                                )}
                                {getScheduled(index) !== '-' && (
                                    <div>
                                        {getText('msg_1cd1bdad468f')}
                                        <span
                                            className={styles.portalsStatus}
                                            style={{ marginLeft: '4px' }}
                                        >
                                            {getScheduled(index)}
                                        </span>
                                    </div>
                                )}
                                <hr />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default AssetNotificationsPanel;
